"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VouchersDialog = void 0;
var _zod = require("@hookform/resolvers/zod");
var _components = require("@ori-ui/components");
var _reactHookForm = require("react-hook-form");
var _zod2 = require("zod");
var _hooks = require("../../hooks");
var _VoucherFormContent = require("../VoucherFormContent/VoucherFormContent");
var _styles = require("./styles");
var _useVoucherDialog = require("./useVoucherDialog");
var _jsxRuntime = require("react/jsx-runtime");
const VouchersDialog = (param)=>{
    let { customerId, isVouchersDialogOpen, onClose, sessionId } = param;
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { handleDialogClose, handleSubmit, error, isVoucherApplied } = (0, _useVoucherDialog.useVoucherDialog)({
        customerId,
        isVouchersDialogOpen,
        onClose,
        sessionId
    });
    const voucherValidationSchema = _zod2.z.object({
        voucherCode: _zod2.z.string().min(1, formatMessage('voucherCodeIsRequired')).max(50, formatMessage('voucherCodeIsTooLong'))
    });
    const form = (0, _reactHookForm.useForm)({
        mode: 'onChange',
        defaultValues: {
            voucherCode: ''
        },
        // There is some random type issue with current zod and @hookform/resolvers versions
        resolver: (0, _zod.zodResolver)(voucherValidationSchema)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Dialog, {
        disablePortal: false,
        open: isVouchersDialogOpen,
        onClose: handleDialogClose,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactHookForm.FormProvider, {
            ...form,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.VouchersForm, {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_VoucherFormContent.VoucherFormContent, {
                    error: error,
                    isVoucherApplied: isVoucherApplied
                })
            })
        })
    });
};
exports.VouchersDialog = VouchersDialog;
